"use strict";

var _classCallCheck = require("/builds/identt/eid/eid-landing-page/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/identt/eid/eid-landing-page/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Attract = void 0;

var Attract = /*#__PURE__*/function () {
  function Attract() {
    _classCallCheck(this, Attract);

    this.enable = false;
    this.rotate = {
      x: 3000,
      y: 3000
    };
  }

  _createClass(Attract, [{
    key: "load",
    value: function load(data) {
      var _a, _b, _c, _d;

      if (data === undefined) {
        return;
      }

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }

      var rotateX = (_b = (_a = data.rotate) === null || _a === void 0 ? void 0 : _a.x) !== null && _b !== void 0 ? _b : data.rotateX;

      if (rotateX !== undefined) {
        this.rotate.x = rotateX;
      }

      var rotateY = (_d = (_c = data.rotate) === null || _c === void 0 ? void 0 : _c.y) !== null && _d !== void 0 ? _d : data.rotateY;

      if (rotateY !== undefined) {
        this.rotate.y = rotateY;
      }
    }
  }, {
    key: "rotateX",
    get: function get() {
      return this.rotate.x;
    },
    set: function set(value) {
      this.rotate.x = value;
    }
  }, {
    key: "rotateY",
    get: function get() {
      return this.rotate.y;
    },
    set: function set(value) {
      this.rotate.y = value;
    }
  }]);

  return Attract;
}();

exports.Attract = Attract;